import { Alert } from 'aha-components';
import { useTranslation } from 'react-i18next';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import { useMultiplePricesStore } from '@/hooks/useMultiplePricesStore';
import ModalNotInterest from '../ModalNotInterest';

export default function DisqualifiedAnswerAlert() {
  const { t } = useTranslation();

  const closeOfferFlow = () => {
    const modals = useWebModalStore.getState();
    modals.setShowModalTakeOrder(false);
    modals.setShowModalAnalysis(false);
    useMultiplePricesStore.getState().clearAllMultiplePricesStore();
  };

  return (
    <div role="alert">
      <Alert
        type="error"
        showIcon
        className="w-full !rounded-lg [&>svg]:mt-0.5 [&>div>div:first-child]:tracking-[-0.16px]"
        title={t('screening_questions.disqualified_title', {
          defaultValue: "This answer doesn't meet the brand's requirements"
        })}
      >
        <p className="m-0 text-sm leading-[22px] tracking-[-0.14px]">
          {t('screening_questions.disqualified_description', {
            defaultValue:
              "With this answer, you won't be able to submit interest in this collaboration. You can change your answer or decline the opportunity."
          })}
        </p>
        <ModalNotInterest
          onSuccess={closeOfferFlow}
          renderTrigger={(open, loading) => (
            <button
              type="button"
              disabled={loading}
              onClick={open}
              className="mt-2 border-0 bg-transparent p-0 text-left font-['Inter'] text-sm font-semibold leading-5 text-[#DC2626]"
            >
              {t('screening_questions.decline_opportunity', {
                defaultValue: 'Decline opportunity'
              })}
            </button>
          )}
        />
      </Alert>
    </div>
  );
}
